import { useTranslation } from 'react-i18next';
import { styled } from 'goober';

import type { TeamMemberSortParams } from '@/api/v4/team.api';
import { AppUserEmptyState } from '@/features/app-users/empty-state';
import { colors } from '@/theme/colors';
import { Table } from '@/ui/table/table';
import type { IHeaderRow, Row } from '@/ui/table/table.types';

import { teamMembersSortState } from '../../team.state';

export const TeamMembersTable = ({
  header,
  rows,
  isLoading,
}: {
  header: IHeaderRow<TeamMemberSortParams>;
  rows: Row[];
  isLoading: boolean;
}) => {
  const { t } = useTranslation('teams');

  return (
    <TableContainer>
      {!isLoading && rows.length === 0 ? (
        <AppUserEmptyState text={t`emptyTeamMembers`} />
      ) : (
        <Table<TeamMemberSortParams>
          isLoading={isLoading}
          headers={header}
          rows={rows}
          sortState={teamMembersSortState}
          borderColor={colors.gray.c2}
        />
      )}
    </TableContainer>
  );
};

const TableContainer = styled('div')`
  width: 100%;
  min-height: 140px;
  padding: 20px 22px;
`;
